import { ProtectedComponent } from '@components'

import React, { ReactElement } from 'react'

import { useIsOrganizationOwner } from '@modules-deprecated/app/organization/hooks/useIsOrganizationOwner'
import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'

import { Scope } from '../../../../enums/scope'
import { BookkeepersSection } from './elements/BookkeepersSection'
import { UsersSection } from './elements/UsersSection'

export const OrganizationSettingsUsers = (): ReactElement => {
  const { isOrganizationOwner } = useIsOrganizationOwner()
  const { isViaUmbrella } = useUserOrganizationMembership()

  // Bookkeepers are only relevant to the organization's owner, or to someone who
  // has access to this organization through an umbrella (e.g. the accounting firm
  // managing it) - matching the umbrellas-api access rules for this data.
  const canSeeBookkeepers = isOrganizationOwner || isViaUmbrella

  return (
    <>
      <ProtectedComponent scopes={Scope.UserRead}>
        <UsersSection />
      </ProtectedComponent>
      {canSeeBookkeepers && <BookkeepersSection />}
    </>
  )
}
